import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import BillingOrderListPage from '@/pages/management/accounts/billing-orders/list';
import BillingOrderCreatePage from '@/pages/management/accounts/billing-orders/new';
import BillingOrderEditPage from '@/pages/management/accounts/billing-orders/edit';
import BillingOrderInformationPage from '@pages/management/accounts/billing-orders/information';

export const billingOrderRoutes = [
  {
    path: 'billing-orders',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
            access={OrionAccess.VIEW}
          >
            <BillingOrderListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
            access={OrionAccess.VIEW}
          >
            <BillingOrderListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
            access={OrionAccess.CREATE}
          >
            <BillingOrderCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
            access={OrionAccess.UPDATE}
          >
            <BillingOrderEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':orderId/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.BILLING_ORDER}
            access={OrionAccess.UPDATE}
          >
            <BillingOrderInformationPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
